"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resolver = void 0;
class Resolver {
    constructor(token) {
        Object.defineProperty(this, "token", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: token
        });
    }
    getToken() {
        if (this.token) {
            return this.token;
        }
        const token = document.cookie
            .split('; ')
            .find((item) => item.startsWith('tb='))
            ?.split('=')[1] || '';
        if (token.length < 1) {
            throw new Error('Token bridge JWT not found');
        }
        return token;
    }
}
exports.Resolver = Resolver;
